<template>
  <div class="tiktok-grid">
    <div
      class="tiktok-grid__lottie-container"
      v-if="gridConfiguration"
    />
    <app-loader-component
      class="tiktok-grid__loader"
      v-else
      width="100px"
      height="100px"
    />
  </div>
</template>

<script>
import lottie from "lottie-web"
import AppLoaderComponent from "@/app/shared/components/base/AppLoaderComponent"

export default {
  name: "TheTikTokGridOverlay",
  components: {
    AppLoaderComponent,
  },
  data: function () {
    return {
      animation: null,
    }
  },
  computed: {
    gridConfiguration: function() {
      return this.$store.getters.getTiktokGridConfiguration
    }
  },
  methods: {
    async initLottieAnimation() {
      if (!this.gridConfiguration) {
        await this.$store.dispatch('fetchTikTokOverlayGrid')
      }
      this.animation = lottie.loadAnimation({
        container: document.querySelector('.tiktok-grid__lottie-container'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: this.gridConfiguration,
        name: 'tiktok-grid'
      })
    },
    destroyLottieAnimation() {
      this.animation.destroy()
    },
  },
  mounted() {
    this.initLottieAnimation()
  },
  beforeDestroy() {
    this.destroyLottieAnimation()
  },
}
</script>

<style lang="scss">
@import "~@/app/styles/blocks/tiktok-grid";
</style>